module.exports = __webpack_public_path__ + "img/logo1 (21).f6e69c1b.jpg";